"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M11.4 9.55c0 .962-.81 1.75-1.8 1.75s-1.8-.788-1.8-1.75c0-.963.81-1.75 1.8-1.75s1.8.787 1.8 1.75zM16.2 9.55c0 .962-.81 1.75-1.8 1.75s-1.8-.788-1.8-1.75c0-.963.81-1.75 1.8-1.75s1.8.787 1.8 1.75zM9.6 12.583c-1.41 0-4.2.671-4.2 2.042V16.2h8.486v-1.575c0-1.37-2.876-2.042-4.286-2.042zM13.886 12.933c.21-.029.335-.029.514-.029 1.41 0 4.2.35 4.2 1.721V16.2h-3.771v-1.575c0-.875-.253-1.196-.943-1.692z" }), "Friends");
//# sourceMappingURL=Friends.js.map